import Auth0Lock from 'auth0-lock';

export default class AuthService {
  constructor(authSettings) {
    this.constants = {
      ID_TOKEN: 'id_token',
      PROFILE: 'profile',
      EXPIRES: 'expires',
      CONTENTFUL_TOKEN: 'contentfulToken'
    };

    this.authSettings = authSettings;

    // Configure Auth0
    this.lock = new Auth0Lock(authSettings.AUTH0_CLIENT_ID, authSettings.AUTH0_DOMAIN, {
      auth: {
        redirectUrl: authSettings.AUTH0_REDIRECT_URL,
        responseType: 'token'
      },
      language: 'nb',
      languageDictionary: {
        title: 'Motorgruppen admin'
      },
      theme: {
        primaryColor: '#1565C0',
        logo: `${authSettings.AUTH0_REDIRECT_URL}/images/motor-gruppen-logo.svg`
      }
    });

    // Callback for lock authenticated
    this.lock.on('authenticated', this._doAuthentication.bind(this));
    this.lock.on('authorization_error', this._doAuthenticationError.bind(this));
    this.isAuthCallback = false;

    // Bind to this context
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.getToken = this.getToken.bind(this);

    this.authenticated = this.authenticated.bind(this);
  }

  _doAuthenticationError(err) {
    console.log(err);
  }

  _doAuthentication(authResult) {
    if (!authResult || !authResult.accessToken || !authResult.idToken || !authResult.idTokenPayload) {
      window.console.error('Det skjedde en feil ved innhenting av brukerdata. Bruker logges ut.');
      this.revokeAuthentication();
      window.location.reload();
      return;
    }

    const expiresAt = (authResult.expiresIn * 1000) + new Date().getTime();

    this.setExpiresAt(expiresAt);
    this.setToken(authResult.idToken);

    if (authResult.idTokenPayload.contentfulToken) {
      this.setContentfulToken(authResult.idTokenPayload.contentfulToken);
      delete authResult.idTokenPayload.contentfulToken;
    }

    this.setUserProfile(authResult.idTokenPayload);

    this.lock.hide();
    const authEvent = new Event('authchange');
    window.dispatchEvent(authEvent);

    if (window.location.search.indexOf('?login&redirect=') !== -1) {
      window.location.href = decodeURIComponent(window.location.search.split('redirect=')[1]);
    }
  }

  login(e) {
    // Show login widget
    if (e) {
      e.preventDefault();
    }
    this.lock.show({
      allowSignUp: false
    });
  }

  logout() {
    // Clear user token and profile data from local storage
    this.revokeAuthentication();

    return true;
  }

  setExpiresAt(expirres) {
    localStorage.setItem(this.constants.EXPIRES, expirres);
  }

  setToken(idToken) {
    // Saves user token to local storage
    localStorage.setItem(this.constants.ID_TOKEN, idToken);
  }

  setUserProfile(profile) {
    localStorage.setItem(this.constants.PROFILE, JSON.stringify(profile));
  }

  setContentfulToken(token) {
    localStorage.setItem(this.constants.CONTENTFUL_TOKEN, token);
  }

  getToken() {
    // Retrieves the user token from local storage
    const idToken = localStorage.getItem(this.constants.ID_TOKEN);

    return idToken;
  }

  getUserProfile() {
    return JSON.parse(localStorage.getItem(this.constants.PROFILE));
  }

  getExpires() {
    return JSON.parse(localStorage.getItem(this.constants.EXPIRES));
  }

  authenticated() {
    return this.getToken() && (new Date().getTime() < this.getExpires());
  }

  revokeAuthentication() {
    localStorage.removeItem(this.constants.ID_TOKEN);
    localStorage.removeItem(this.constants.PROFILE);
    localStorage.removeItem(this.constants.EXPIRES);
    localStorage.removeItem(this.constants.CONTENTFUL_TOKEN);
  }

  isAuthorized(route) {
    // Checks if user have `admin` role in his profile app_metadata
    const profile = this.getUserProfile() || {};
    const {roles} = profile.app_metadata || {};

    // Test if user has admin role to specific route
    return Boolean(roles) && (roles.indexOf('admin') > -1 || roles.indexOf(`admin_${route}`) > -1);
  }
}
